import classNames from 'classnames';
import { useCallback, useEffect, useRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

const AddressSearchField = ({
  name, label, placeholder, onAutocomplete,
}) => {
  const { control } = useFormContext();

  const autocompleteRef = useRef(null);
  const containerRef = useRef(null);
  const inputRef = useRef(null);

  const onChange = useCallback(() => {
    const addressObject = autocompleteRef.current.getPlace();
    onAutocomplete(addressObject.address_components);
  }, [onAutocomplete]);

  useEffect(() => {
    if (window.google && !autocompleteRef.current) {
      autocompleteRef.current = new window.google.maps.places.Autocomplete(
        inputRef.current,
        {
          componentRestrictions: { country: 'us' },
          types: ['address'],
        },
      );
      autocompleteRef.current.setFields([
        'address_components',
        'formatted_address',
      ]);
      autocompleteRef.current.addListener('place_changed', onChange);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onChange, window.google]);

  return (
    <div className="form-control" ref={containerRef}>
      <label
        className="form-control__label"
        htmlFor={name}
      >
        {label}
      </label>

      <Controller
        render={({ field, fieldState }) => (
          <>
            <input
              {...field}
              id={name}
              data-testid={name}
              ref={(e) => {
                field.ref(e);
                inputRef.current = e;
              }}
              placeholder={placeholder}
              className={classNames('form-control__input', { 'has-error': !!fieldState.error })}
            />
            {fieldState.error && (
              <span className="form-control__error">
                {fieldState.error.message}
              </span>
            )}
          </>
        )}
        control={control}
        name={name}
      />
    </div>
  );
};

export default AddressSearchField;
